import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import SimpleLine from '../ChartComponents/SimpleLine';
import { statisticsUserListRequest } from '../../../../redux/actions/monitoring/statisticsActions';
import { DAYS_AGO, DIFF_VALUE } from '../../../../constants/base';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import TextField from '@mui/material/TextField';
import Notification from '../../../../components/Notification/Notification';
import BtnIcons from '../../../../api/images/btnIcons';
import { DatePicker } from '@mui/x-date-pickers';
import { Helmet } from 'react-helmet';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringUser from "../../../../schema/table-schema/useSchemaMonitoringUser";
import FetchLoading from "../../../../components/Loading/FetchLoading";
import DataItem from "../DataItem";
import {
  SearchBtn,
  SearchBtnContainer,
  SearchContainer,
  SearchDateRange,
  SearchLabel,
  SearchRow
} from "../../../../components/Search/searchSection";

function UserMain() {
  // -- component const --//
  const title = '유저';

  const tHead = [
    '날짜', '총 회원 수', '이용정지 회원 수', '신규 회원 수', '로그인 회원 수', '활성 회원 수',
    '총 홀더 수', '이용정지 홀더 수', '로그인 홀더 수',
    '액티브 홀더 수', '홀더 전환 수', '비홀더 전환 수', '최초 홀더 전환 수',
  ];

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 날짜 범위
  const [activeDateRangeToken, setActiveDateRangeToken] = useState(7);
  const [startAt, setStartAt] = useState(DAYS_AGO(activeDateRangeToken));
  const [endAt, setEndAt] = useState(DAYS_AGO(1));

  // 데이터 설정
  const [strData, setStrData] = useState([{}]);
  const [tableData, setTableData] = useState([{}]);

  const [data, setData] = useState([{}]);
  const [dataHolder, setDataHolder] = useState([{}]);
  const [lineDataAccount, setLineDataAccount] = useState([{}]);
  const [lineDataHolder, setLineDataHolder] = useState([{}]);

  const schema = useSchemaMonitoringUser();
  const [rows, setRows] = useState([]);
  const [tBody, setTbody] = useState([]);

  // useEffect(() => {
  //   let parseList = []
  //
  //   tBody.map((row, index) => {
  //      const content = {
  //         index: index,
  //         targetDate: row?.targetDate,
  //         totalAccountCount: row?.totalAccountCount,
  //         suspendedAccountCount: row?.suspendedAccountCount,
  //         newAccountCount: row?.newAccountCount,
  //         signInAccountCount: row?.signInAccountCount,
  //         activatedAccountCount: row?.activatedAccountCount,
  //         totalHolderCount: row?.totalHolderCount,
  //         suspendedHolderCount: row?.suspendedHolderCount,
  //         signInHolderCount: row?.signInHolderCount,
  //         activatedHolderCount: row?.activatedHolderCount,
  //         convertedHolderCount: row?.convertedHolderCount,
  //         convertedNonHolderCount: row?.convertedNonHolderCount,
  //         convertedFirstHolderCount: row?.convertedFirstHolderCount
  //      }
  //
  //      console.log(content);
  //
  //      parseList.push(content);
  //
  //   })
  //
  //   setRows(parseList)
  // }, [tBody])

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);
  const [isLoadingGraphHolder, setIsLoadingGraphHolder] = useState(false);

  // -- func & handler --//
  const fetchList = () => {

    setIsLoading(true);
    setIsLoadingGraph(true);
    setIsLoadingGraphHolder(true);

    dispatch(
      statisticsUserListRequest({
        beginDate: startAt,
        endDate: endAt,
        callback: (data) => {
          console.log('요청 결과: ', data);

          setData(data?.list);
          setDataHolder(data?.list);
          setTbody(data?.list?.map(item => {
            const { firstPlayAccountCount, ...rest } = item;
            return rest;
          }));

          setRows(data?.list);

          setIsLoadingGraph(false);
          setIsLoadingGraphHolder(false);

        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      })
    );

    setIsLoading(false);

  };

  const handleClickDownload = () => {
    // 파일 명 설정
    const fileName = `유저_${startAt}_${endAt}`;

    excelDownload(fileName, tBody, sortKey.statistics.user);
  };

  // -- react hooks --//
  useEffect(() => {
    setStartAt(DAYS_AGO(activeDateRangeToken));
    setEndAt(DAYS_AGO(1))
  }, [activeDateRangeToken]);

  useEffect(() => {
    fetchList();

    setIsLoading(true);

    // 유저 현황 조회
    dispatch(
      statisticsUserListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, []);

  // 현황 데이터
  useEffect(() => {
    const updateData = strData?.map(data => {
      // 회원 지표
      const totalAccountCount = data?.totalAccountCount || 0;
      const suspendedAccountCount = data?.suspendedAccountCount || 0;
      const newAccountCount = data?.newAccountCount || 0;
      const signInAccountCount = data?.signInAccountCount || 0;

      // 홀더 지표
      const totalHolderCount = data?.totalHolderCount || 0;
      const suspendedHolderCount = data?.suspendedHolderCount || 0;
      const signInHolderCount = data?.signInHolderCount || 0;
      const activatedHolderCount = data?.activatedHolderCount || 0;

      const convertedHolderCount = data?.convertedHolderCount || 0;
      const convertedNonHolderCount = data?.convertedNonHolderCount || 0;
      const convertedFirstHolderCount = data?.convertedFirstHolderCount || 0;

      const activatedAccountCount = data?.activatedAccountCount || 0;

      // 날짜
      const targetDate = data?.targetDate;

      return {
        totalAccountCount: totalAccountCount,
        suspendedAccountCount: suspendedAccountCount,
        newAccountCount: newAccountCount,
        signInAccountCount: signInAccountCount,
        activatedAccountCount: activatedAccountCount,

        totalHolderCount: totalHolderCount,
        suspendedHolderCount: suspendedHolderCount,
        signInHolderCount: signInHolderCount,
        activatedHolderCount: activatedHolderCount,

        convertedHolderCount: convertedHolderCount,
        convertedNonHolderCount: convertedNonHolderCount,
        convertedFirstHolderCount: convertedFirstHolderCount,

        targetDate: targetDate,
      }
    });

    setTableData(updateData);
  }, [strData]);

  // 요청해서 온 데이터 디자인에 맞게 key 가공
  useEffect(() => {
    const updateData = data && data?.map(data => {
      // 회원 지표
      const totalAccountCount = data?.totalAccountCount || 0;

      // 홀더 지표
      const totalHolderCount = data?.totalHolderCount || 0;

      // 날짜
      const newDate = timeFormAPI.changeDataDate(data?.targetDate);

      return {
        '총 회원 수': parseFloat(totalAccountCount),
        '총 홀더 수': parseFloat(totalHolderCount),

        time: newDate
      };
    });

    setLineDataAccount(updateData)

    const updateDataHolder = dataHolder && dataHolder.map(data => {
      // 회원 지표
      const newAccountCount = data?.newAccountCount || 0;

      // 홀더 지표
      const convertedHolderCount = data?.convertedHolderCount || 0;
      const convertedNonHolderCount = data?.convertedNonHolderCount || 0;

      // 날짜
      const newDate = timeFormAPI.changeDataDate(data?.targetDate);

      return {
        '신규 회원 수': parseFloat(newAccountCount),
        '신규 홀더 수': parseFloat(convertedHolderCount),
        '비홀더 전환 수': parseFloat(convertedNonHolderCount),

        time: newDate
      };
    });

    setLineDataHolder(updateDataHolder)
  }, [data, dataHolder]);

  // -- render --//
  return (
    <div className="page over">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSection">
        <div className="leftSection">
          <p className="titleText">{title}</p>
        </div>
      </div>

      <div className="spaceDiv10"/>

        <div className="contentsArea">
          <div className="rowDiv">
            <div className="leftDiv" style={{width:'100%'}}>
              <div className={"contentTitle"}>
                유저 현황 {`(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준)`}
              </div>
            </div>

          </div>

          <div className="spaceDiv10"/>

          {
            isLoading ?
                <FetchLoading/>
              : tableData.slice(0, -1)
                .map((data, index) => (

                  <div key={index} style={{padding: "10px 15px"}}>
                    <div className="rowDiv">
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%'
                      }}>
                        <div style={{ display: 'flex', gap: 5 }}>

                          <DataItem
                              label="총 회원"
                              value={tableData[index + 1]?.totalAccountCount}
                              prevValue={tableData[index]?.totalAccountCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="이용정지 회원"
                              value={tableData[index + 1]?.suspendedAccountCount}
                              prevValue={tableData[index]?.suspendedAccountCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="신규 회원"
                              value={tableData[index + 1]?.newAccountCount}
                              prevValue={tableData[index]?.newAccountCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="로그인 회원"
                              value={tableData[index + 1]?.signInAccountCount}
                              prevValue={tableData[index]?.signInAccountCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="활성 회원"
                              value={tableData[index + 1]?.activatedAccountCount}
                              prevValue={tableData[index]?.activatedAccountCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                        </div>

                      </div>
                    </div>

                    <div className="spaceDiv10"/>
                    <div className="spaceDiv10"/>

                    <div className="rowDiv">

                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%'
                      }}>
                        <div style={{ display: 'flex', gap: 5 }}>

                          <DataItem
                              label="총 홀더"
                              value={tableData[index + 1]?.totalHolderCount}
                              prevValue={tableData[index]?.totalHolderCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="이용 정지 홀더"
                              value={`${tableData[index + 1]?.suspendedHolderCount} `}
                              prevValue={tableData[index]?.suspendedHolderCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="로그인 홀더"
                              value={tableData[index + 1]?.signInHolderCount}
                              prevValue={tableData[index]?.signInHolderCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="액티브 홀더"
                              value={tableData[index + 1]?.activatedHolderCount}
                              prevValue={tableData[index]?.activatedHolderCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <div
                              style={{width: "25%"}}
                          />
                        </div>

                      </div>
                    </div>

                    <div className="spaceDiv10"/>
                    <div className="spaceDiv10"/>

                    <div className="rowDiv">

                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%'
                      }}>
                        <div style={{ display: 'flex', gap: 5 }}>
                          <DataItem
                              label="홀더 전환"
                              value={`${tableData[index + 1]?.convertedHolderCount} `}
                              prevValue={tableData[index]?.convertedHolderCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="비홀더 전환"
                              value={tableData[index + 1]?.convertedNonHolderCount}
                              prevValue={tableData[index]?.convertedNonHolderCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <DataItem
                              label="최초 홀더 전환"
                              value={tableData[index + 1]?.convertedFirstHolderCount}
                              prevValue={tableData[index]?.convertedFirstHolderCount}
                              targetDate={tableData[index + 1]?.targetDate}
                          />

                          <div style={{ width: '25%', }}/>
                          <div style={{ width: '25%',}}/>
                        </div>

                      </div>
                    </div>
                  </div>

                ))
          }

        </div>


      <div className="spaceDiv10"/>

      <SearchContainer>
        <SearchRow>
          <SearchLabel text={"날짜"}/>
          <SearchDateRange
              startAt={startAt}
              endAt={endAt}
              setStartAt={setStartAt}
              setEndAt={setEndAt}
          />
          <SearchBtn
              handleSearchClick={() => {
                fetchList();
              }}
          />
        </SearchRow>

        {/*<SearchBtnContainer*/}
        {/*    handleSearchClick={() => {*/}
        {/*      fetchList();*/}
        {/*    }}*/}
        {/*    handleResetClick={() => {*/}
        {/*      setStartAt(DAYS_AGO(activeDateRangeToken));*/}
        {/*      setEndAt(DAYS_AGO(1));*/}
        {/*    }}*/}
        {/*/>*/}
      </SearchContainer>

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        유저 지표 조회 및 다운로드 조건*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}

      {/*      </div>*/}
      {/*    </div>*/}

      {/*    <div className="spaceDiv10"/>*/}

      {/*    <div className="descDiv" style={{ alignItems: 'center', justifyContent: 'space-between' }}>*/}
      {/*      <div style={{*/}
      {/*        display: 'flex',*/}
      {/*        gap: 5,*/}
      {/*        alignItems: 'center'*/}
      {/*      }}>*/}
      {/*        <div className="descDiv dateSmall">*/}
      {/*          <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*            <DatePicker*/}
      {/*              onChange={(date) => {*/}
      {/*                setStartAt(date.format('YYYY-MM-DD'));*/}
      {/*              }}*/}
      {/*              value={startAt}*/}
      {/*              renderInput={(params) => (*/}
      {/*                <TextField {...params} variant="standard"/>*/}
      {/*              )}*/}
      {/*            />*/}
      {/*          </LocalizationProvider>*/}

      {/*          <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*            <DatePicker*/}
      {/*              onChange={(date) => {*/}
      {/*                setEndAt(date.format('YYYY-MM-DD'));*/}
      {/*              }}*/}
      {/*              value={endAt}*/}
      {/*              renderInput={(params) => (*/}
      {/*                <TextField {...params} variant="standard"/>*/}
      {/*              )}*/}
      {/*            />*/}
      {/*          </LocalizationProvider>*/}

      {/*        </div>*/}

      {/*        <button*/}
      {/*          className={`dateSelectBox ${activeDateRangeToken === 7 ? 'active' : ''*/}
      {/*          }`}*/}
      {/*          onClick={() => {*/}
      {/*            setActiveDateRangeToken(7);*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          주*/}
      {/*        </button>*/}
      {/*        <button*/}
      {/*          className={`dateSelectBox ${activeDateRangeToken === 30 ? 'active' : ''*/}
      {/*          }`}*/}
      {/*          onClick={() => {*/}
      {/*            setActiveDateRangeToken(30);*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          월*/}
      {/*        </button>*/}
      {/*        <button*/}
      {/*          className={`dateSelectBox ${activeDateRangeToken === 90 ? 'active' : ''*/}
      {/*          }`}*/}
      {/*          onClick={() => {*/}
      {/*            setActiveDateRangeToken(90);*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          3개월*/}
      {/*        </button>*/}

      {/*        <button className="defaultBtn"*/}
      {/*                onClick={() => {*/}
      {/*                  fetchList();*/}
      {/*                }}*/}
      {/*        >*/}
      {/*          조회*/}
      {/*        </button>*/}

      {/*        <button className="purple" onClick={handleClickDownload}>*/}
      {/*          <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*/}
      {/*          엑셀 다운로드*/}
      {/*        </button>*/}
      {/*      </div>*/}

      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      <div className="spaceDiv10"/>

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        회원 지표*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}

      {/*      </div>*/}
      {/*    </div>*/}

      {/*    <div className="spaceDiv10"/>*/}

      {/*  </div>*/}

      {/*  <div className="spaceDiv10"/>*/}

      {/*  {*/}
      {/*    isLoadingGraph ? (*/}
      {/*        <div className="rowDiv" style={{*/}
      {/*          width: '100%',*/}
      {/*          height: 520,*/}
      {/*          display: 'flex',*/}
      {/*          justifyContent: 'center',*/}
      {/*          padding: 'unset'*/}
      {/*        }}>*/}
      {/*          Loading...*/}
      {/*        </div>*/}
      {/*      )*/}
      {/*      : <div className="rowDiv" style={{*/}
      {/*        height: 520,*/}
      {/*        padding: 'unset'*/}
      {/*      }}>*/}
      {/*        <div className="descDiv" style={{*/}
      {/*          width: '100%',*/}
      {/*          height: '100%'*/}
      {/*        }}>*/}
      {/*          <SimpleLine data={lineDataAccount}/>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*  }*/}

      {/*</div>*/}

      {/*<div className="spaceDiv10"/>*/}

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        홀더 지표*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}

      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className="spaceDiv10"/>*/}

      {/*  {*/}
      {/*    isLoadingGraphHolder ? (*/}
      {/*        <div className="rowDiv" style={{*/}
      {/*          width: '100%',*/}
      {/*          height: 520,*/}
      {/*          display: 'flex',*/}
      {/*          justifyContent: 'center',*/}
      {/*          padding: 'unset'*/}
      {/*        }}>*/}
      {/*          Loading...*/}
      {/*        </div>*/}
      {/*      )*/}
      {/*      : <div className="rowDiv" style={{*/}
      {/*        height: 520,*/}
      {/*        padding: 'unset'*/}
      {/*      }}>*/}
      {/*        <div className="descDiv" style={{*/}
      {/*          width: '100%',*/}
      {/*          height: '100%'*/}
      {/*        }}>*/}
      {/*          <SimpleLine data={lineDataHolder}/>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*  }*/}

      {/*</div>*/}

      {/*<div className="spaceDiv10"/>*/}

      {/*<table>*/}
      {/*  <thead>*/}
      {/*  <tr>*/}
      {/*    {tHead.map((i, index) => (*/}
      {/*      <th key={index} className="">*/}
      {/*        {i}*/}
      {/*      </th>*/}
      {/*    ))}*/}
      {/*  </tr>*/}
      {/*  </thead>*/}
      {/*  <tbody>*/}
      {/*  {isLoading ? (*/}
      {/*    <tr>*/}
      {/*      <td*/}
      {/*        colSpan={tHead.length}*/}
      {/*        style={{*/}
      {/*          textAlign: 'center',*/}
      {/*          backgroundColor: '#FAFBFC'*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        Loading...*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*  ) : tBody.length > 0 ? (*/}
      {/*    tBody.map((row, index) => (*/}
      {/*      <tr key={index}>*/}
      {/*        <td className="">{timeFormAPI.changeDataDate(row?.targetDate)}</td>*/}
      {/*        <td className="">{row?.totalAccountCount}</td>*/}
      {/*        <td className="">{row?.suspendedAccountCount}</td>*/}
      {/*        <td className="">{row?.newAccountCount}</td>*/}
      {/*        <td className="">{row?.signInAccountCount}</td>*/}
      {/*        <td className="">{row?.activatedAccountCount}</td>*/}
      {/*        <td className="">{row?.totalHolderCount}</td>*/}
      {/*        <td className="">{row?.suspendedHolderCount}</td>*/}
      {/*        <td className="">{row?.signInHolderCount}</td>*/}
      {/*        <td className="">{row?.activatedHolderCount}</td>*/}
      {/*        <td className="">{row?.convertedHolderCount}</td>*/}
      {/*        <td className="">{row?.convertedNonHolderCount}</td>*/}
      {/*        <td className="">{row?.convertedFirstHolderCount}</td>*/}
      {/*      </tr>*/}
      {/*    ))*/}
      {/*  ) : (*/}
      {/*    <tr>*/}
      {/*      <td*/}
      {/*        colSpan={tHead.length}*/}
      {/*        style={{*/}
      {/*          textAlign: 'center',*/}
      {/*          backgroundColor: '#FAFBFC'*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        등록된 로그 정보가 없습니다.*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*  )}*/}
      {/*  </tbody>*/}
      {/*</table>*/}

      <BOTable
          schema={schema}
          rows={rows}
          loading={isLoadingGraph}
          maxHeight={"65vh"}
      />

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  );
}

export default UserMain;
